export default function containsUpperChar(value) {
    var UPPER = /[A-Z]/;
    return UPPER.test(value);
}
